export default "__VITE_ASSET__I325d3$d__"